module.exports = __webpack_public_path__ + "static/media/logo_horizontal.8216fd8b.png";